import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';

export const StyledItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 0;

  @media ${sizes.desktop} {
    gap: 8px;
  }

  :not(:last-child) {
    border-bottom: 1px solid ${th('colors.pickledBluewood35')};
  }

  :last-child {
    padding-bottom: 0;

    @media ${sizes.desktop} {
      padding-bottom: 16px;
    }
  }
`;

export const Heading = styled.div`
  font-weight: 500;
`;

export const Children = styled.div`
  color: ${th('colors.pickledBluewood1')};
`;
